import { Object3D } from "./object3d";
import { calculateCentroid } from "../math/utils";
export class Geometry extends Object3D {
    constructor(vertices, faces) {
        super();
        this.vertices = vertices;
        this.faces = faces;
        this.centroid = calculateCentroid(this.vertices);
    }
}
